export default "__VITE_ASSET__CNXk9oSp__"